import { StaticImage } from 'gatsby-plugin-image';
import uuid from 'react-uuid';
import React from 'react';
import ConfidentialFolder from '../../technology/assets/images/federated-learning/confidential-folder';
import FederatedLearningGeneralGraph from '../../technology/assets/images/federated-learning/federated-learning-general-graph';
import PrivacyLegislation from '../../technology/assets/images/federated-learning/privacy-legislation';
import Sharing from '../../technology/assets/images/federated-learning/sharing';
import OtherAspectsMultiParty from '../../technology/assets/images/privacy-preserving/other-aspects-multi-party';
import BrandSVG from '../components/svg/brand-svg';

const images = {
  // GLOBAL
  'sherpa-white-logo': <BrandSVG />,
  // HOME
  'home-client-logos': [
    <StaticImage
      className='logo-nih'
      src='../../home/assets/images/logos/nih.png'
      alt='logo of nih'
      objectFit='contain'
      placeholder='blurred'
      key={uuid()}
    />,
    <StaticImage
      className='logo-kpmg'
      src='../../home/assets/images/logos/kpmg.png'
      alt='logo of kpmg'
      objectFit='contain'
      placeholder='blurred'
      key={uuid()}
    />,
    <StaticImage
      className='logo-telefonica'
      src='../../home/assets/images/logos/telefonica.png'
      alt='logo of telefonica'
      objectFit='contain'
      placeholder='blurred'
      key={uuid()}
    />,
    <StaticImage
      className='logo-prosegur'
      src='../../home/assets/images/logos/logo-cliente-prosegur.png'
      alt='logo of prosegur'
      objectFit='contain'
      placeholder='blurred'
      key={uuid()}
    />,
    <StaticImage
      className='logo-osakidetza'
      src='../../home/assets/images/logos/logo-cliente-osakidetza.png'
      alt='logo of osakidetza'
      objectFit='contain'
      placeholder='blurred'
      key={uuid()}
    />,
    <StaticImage
      className='logo-orange'
      src='../../home/assets/images/logos/logo-cliente-orange.png'
      alt='logo of orange'
      objectFit='contain'
      placeholder='blurred'
      key={uuid()}
    />,
    <StaticImage
      className='logo-zurich'
      src='../../home/assets/images/logos/logo-cliente-zurich.png'
      alt='logo of zuric'
      objectFit='contain'
      placeholder='blurred'
      key={uuid()}
    />,
  ],
  'home-comments-xabi-thumb': (
    <StaticImage
      src='../../home/assets/images/comments/xabi-sherpa.png'
      alt='profile picture of xabi uribe-etxebarria'
      objectFit='contain'
      placeholder='blurred'
      width={68}
      height={68}
      quality={90}
    />
  ),
  'home-comments-tom-thumb': (
    <StaticImage
      src='../../home/assets/images/comments/tom-sherpa.png'
      alt='profile picture of tom gruber'
      objectFit='contain'
      placeholder='blurred'
      width={68}
      height={68}
      quality={90}
    />
  ),
  'home-comments-doug-thumb': (
    <StaticImage
      src='../../home/assets/images/comments/doug-sherpa.png'
      alt='profile picture of doug solomon'
      objectFit='contain'
      placeholder='blurred'
      width={68}
      height={68}
      quality={90}
    />
  ),
  'home-comments-chris-thumb': (
    <StaticImage
      src='../../home/assets/images/comments/chris-sherpa.png'
      alt='profile picture of chris shipley'
      objectFit='contain'
      placeholder='blurred'
      width={68}
      height={68}
      quality={90}
    />
  ),
  'home-awards-cognitionx-logo': (
    <StaticImage
      className='logo-award'
      src='../../home/assets/images/logos/logo-sherpa-cogx.png'
      alt='cogx winner 2021 award'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'home-awards-aitech-logo': (
    <StaticImage
      className='logo-award'
      src='../../home/assets/images/logos/logo-sherpa-aitech.png'
      alt='ai tech awards 2021'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'home-awards-best10ai-logo': (
    <StaticImage
      className='logo-award'
      src='../../home/assets/images/logos/logo-sherpa-best10ai.png'
      alt='top 10 artificial intelligence companies award'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'home-awards-topai100-logo': (
    <StaticImage
      className='logo-award'
      src='../../home/assets/images/logos/logo-sherpa-topai100.png'
      alt='the 100 most promising private ai companies in the world award'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'home-awards-intelligence-logo': (
    <StaticImage
      className='logo-award'
      src='../../home/assets/images/logos/logo-intelligence.png'
      alt='b intelligence award'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'home-awards-red-herring-europe-logo': (
    <StaticImage
      className='logo-award'
      src='../../home/assets/images/logos/logo-red-herring-europe.png'
      alt='red herring europe winner'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'home-awards-digital-talent-logo': (
    <StaticImage
      className='logo-award'
      src='../../home/assets/images/logos/logo-digital-talent.png'
      alt='premios digital talent award'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'home-compliance-gdpr': (
    <StaticImage
      src='../../home/assets/images/compliance/gdpr-logo-sherpa.png'
      alt='logo of general data protection regulation'
      placeholder='blurred'
    />
  ),
  'home-compliance-hipaa-hitech': (
    <StaticImage
      src='../../home/assets/images/compliance/hipaa-hitech-compliance-logo.png'
      alt='logo of HIPAA HITECH'
      placeholder='blurred'
    />
  ),
  'home-compliance-ccpa': (
    <StaticImage
      src='../../home/assets/images/compliance/ccpa-compliance-logo.png'
      alt='logo of CCPA'
      placeholder='blurred'
    />
  ),
  'home-compliance-urs-ukas': (
    <StaticImage
      src='../../home/assets/images/compliance/urs-ukas-logo-sherpa.png'
      alt='united registrar of systems iso 27001 and ukas management systems logos'
      placeholder='blurred'
    />
  ),
  'home-compliance-privacy-extra-logos': [
    <StaticImage
      src='../../home/assets/images/compliance/cogx-winner-2021-logo-sherpa.png'
      alt='logo of cogx 2021 winner'
      placeholder='blurred'
      key={uuid()}
    />,
    <StaticImage
      src='../../home/assets/images/compliance/cogx-finalist-2021-logo-sherpa.png'
      alt='logo of cogx 2021 finalist'
      placeholder='blurred'
      key={uuid()}
    />,
  ],
  'home-compliance-privacy-extra-logos-mobile': [
    <StaticImage
      src='../../home/assets/images/compliance/cogx-winner-2021-logo-mobile-sherpa.png'
      alt='small logo of cogx 2021 winner'
      placeholder='blurred'
      key={uuid()}
    />,
    <StaticImage
      src='../../home/assets/images/compliance/cogx-finalist-2021-logo-mobile-sherpa.png'
      alt='small logo of cogx 2021 finalist'
      placeholder='blurred'
      key={uuid()}
    />,
  ],
  'home-press-quotes-fortune': (
    <StaticImage
      src='../../home/assets/images/press-quotes/fortune-logo-sherpa.png'
      alt='logo of fortune'
      width={112}
      height={27}
      placeholder='blurred'
    />
  ),
  'home-press-quotes-red-herring': (
    <StaticImage
      src='../../home/assets/images/press-quotes/red-herring-logo-sherpa.png'
      alt='logo of red herring'
      width={73}
      height={38}
      placeholder='blurred'
    />
  ),
  'home-press-quotes-tech-crunch': (
    <StaticImage
      src='../../home/assets/images/press-quotes/tech-crunch-logo-sherpa.png'
      alt='logo of tech crunch'
      width={66}
      height={33}
      placeholder='blurred'
    />
  ),
  'home-press-quotes-time': (
    <StaticImage
      src='../../home/assets/images/press-quotes/time-logo-sherpa.png'
      alt='logo of time'
      width={111}
      height={34}
      placeholder='blurred'
    />
  ),
  'home-featured-quote-fortune': (
    <StaticImage
      src='../../home/assets/images/featured-quote/fortune.png'
      alt='fortune profile picture'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'home-featured-quote-logo-fortune': (
    <StaticImage
      src='../../home/assets/images/featured-quote/fortune-logo.png'
      alt='fortune profile picture'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'home-featured-quote-kpmg': (
    <StaticImage
      src='../../home/assets/images/featured-quote/luis-buzzi.png'
      alt='luis buzzi profile picture'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'home-featured-quote-gonzalo-martin-villa': (
    <StaticImage
      src='../../home/assets/images/featured-quote/gonzalo-martin-villa.jpg'
      alt='gonzalo martin villa profile picture'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'home-featured-quote-logo-kpmg': (
    <StaticImage
      src='../../home/assets/images/featured-quote/kpmg-logo.png'
      alt='luis buzzi profile picture'
      objectFit='contain'
      placeholder='blurred'
    />
  ),

  'home-featured-quote-logo-telefonica': (
    <StaticImage
      src='../../home/assets/images/featured-quote/telefonica-logo.png'
      alt='telefonica profile picture'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'home-federated-learning-traditional-solution': (
    <StaticImage
      src='../../shared/assets/images/federated-learning/federated-learning-traditional-solution.png'
      alt='federated learning profile picture'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'home-federated-learning-sherpa-solution': (
    <StaticImage
      src='../../shared/assets/images/federated-learning/federated-learning-sherpa-solution.png'
      alt='federated learning profile picture'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'home-plant-leaves': (
    <StaticImage
      src='../../home/assets/images/federated-learning/plant-leaves.png'
      alt='picture shows plant leaves in green color'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  // SOLUTIONS
  'card-item-insurance-zurich': (
    <StaticImage
      className='logo-zurich'
      src='../../home/assets/images/logos/logo-cliente-zurich.png'
      alt='logo of zurich'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'card-item-health-nih': (
    <StaticImage
      className='logo-osakidetza'
      src='../../home/assets/images/logos/logo-cliente-osakidetza.png'
      alt='logo of osakidetza'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'card-item-telco-orange': (
    <StaticImage
      className='logo-orange'
      src='../../home/assets/images/logos/logo-cliente-orange.png'
      alt='logo of orange'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'card-item-media-prisa': (
    <StaticImage
      className='logo-prisa'
      src='../../home/assets/images/logos/logo-cliente-prisa.png'
      alt='logo of prisa'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'solutions-covid': (
    <StaticImage
      src='../../shared/assets/images/covid/covid.jpeg'
      alt='prediction of the impact of covid19 on the bac and osakidetza health centers with the help of sherpa.ai'
      placeholder='blurred'
    />
  ),
  'solutions-inner-join-sherpa': (
    <StaticImage
      src='../../solutions/assets/images/federated-learning/inner-join-sherpa.png'
      alt='different scenarios with sherpa.ai in the center'
      placeholder='blurred'
    />
  ),

  // USE CASES
  'prosegur-intro': (
    <StaticImage
      src='../../use-cases/prosegur/assets/images/prosegur.png'
      alt='picture of prosegur use case'
      placeholder='blurred'
    />
  ),
  'nih-intro': (
    <StaticImage src='../../use-cases/nih/assets/images/nih.png' alt='picture of nih use case' placeholder='blurred' />
  ),
  'covid-intro': (
    <StaticImage
      src='../../use-cases/nih/assets/images/covid.webp'
      alt='picture of covid use case'
      placeholder='blurred'
    />
  ),
  'orange-and-zurich-intro': (
    <StaticImage
      src='../../use-cases/orange-and-zurich/assets/images/orange-and-zurich.png'
      alt='picture of orange-and-zurich use case'
      placeholder='blurred'
    />
  ),
  'telefonica-intro': (
    <StaticImage
      src='../../use-cases/telefonica/assets/images/telefonica.png'
      alt='picture of telefonica use case'
      placeholder='blurred'
    />
  ),
  'prisa-intro': (
    <StaticImage
      src='../../use-cases/prisa/assets/images/background-header-image.png'
      alt='picture of prisa use case'
      placeholder='blurred'
    />
  ),

  // TECHNOLOGY
  'technology-federated-learning-intro': <FederatedLearningGeneralGraph />,
  'technology-federated-learning-use-case-confidential-info': <ConfidentialFolder />,
  'technology-federated-learning-use-case-privacy-legislation': <PrivacyLegislation />,
  'technology-federated-learning-use-case-sharing': <Sharing />,
  'how-does-screen': (
    <StaticImage
      src='../../technology/assets/images/how-does-sherpa.png'
      alt='how does screenshot'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'federated-learning-traditional-solution': (
    <StaticImage
      src='../../technology/assets/images/federated-learning/federated-learning-traditional-solution.png'
      alt='federated learning profile picture'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'federated-learning-sherpa-solution': (
    <StaticImage
      src='../../technology/assets/images/federated-learning/federated-learning-sherpa-solution.png'
      alt='federated learning profile picture'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'diferencial-privacy__ai-platform': (
    <StaticImage
      src='../../technology/assets/images/privacy-preserving/diferencial-privacy__ai-platform.png'
      alt='diferencial-privacy'
    />
  ),
  'hemomorphic-encryption': (
    <StaticImage
      src='../../technology/assets/images/privacy-preserving/hemomorphic-encryption.png'
      alt='hemomorphic-encryption'
    />
  ),
  'federated-learning-generations': (
    <StaticImage
      src='../../technology/assets/images/federated-learning/federated-learning-generations.png'
      alt='schema of federated learning generations'
      objectFit='contain'
      placeholder='blurred'
      quality={90}
    />
  ),
  'federated-coming': (
    <StaticImage
      src='../../technology/assets/images/federated-learning/federate-coming.png'
      alt='schema of federated coming soon'
      objectFit='contain'
      placeholder='blurred'
      quality={90}
    />
  ),
  'horizontal-federated-learning-types-desktop': (
    <StaticImage
      src='../../technology/assets/images/federated-learning/horizontal-federated-learning.png'
      alt='schema of horizontal federated learning'
      objectFit='contain'
      placeholder='blurred'
      quality={90}
    />
  ),
  'vertical-federated-learning-types-desktop': (
    <StaticImage
      src='../../technology/assets/images/federated-learning/vertical-federated-learning.png'
      alt='schema of vertical federated learning'
      objectFit='contain'
      placeholder='blurred'
      quality={90}
    />
  ),
  'transfer-federated-learning-types-desktop': (
    <StaticImage
      src='../../technology/assets/images/federated-learning/transfer-federated-learning.png'
      alt='schema of federated transfer learning'
      objectFit='contain'
      placeholder='blurred'
      quality={90}
    />
  ),
  'technology-other-aspects-differential-privacy': (
    <StaticImage
      src='../../technology/assets/images/privacy-preserving/other-aspects-differential-privacy.png'
      alt='mathematical definition of differential privacy where noise is added to the raw dataset to create a secure dataset'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'technology-other-aspects-multi-party': <OtherAspectsMultiParty />,
  'technology-comments-enrique-thumb': (
    <StaticImage
      src='../../home/assets/images/comments/enrique-sherpa.png'
      alt='profile picture of enrique zuazua'
      objectFit='contain'
      placeholder='blurred'
      width={68}
      height={68}
      quality={90}
    />
  ),
  'technology-differencial-privacy-image-1': (
    <StaticImage
      src='../../technology/assets/images/differential_privacy.png'
      alt='schema of differential privacy'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'technology-robust-defense-image-1': (
    <StaticImage
      src='../../technology/assets/images/attacks2.png'
      alt='schema of defense against data attacks'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'technology-robust-defense-image-2': (
    <StaticImage
      src='../../technology/assets/images/attacks4.png'
      alt='schema of defense against membership inference attacks'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'technology-poisining-attacks-image-1': (
    <StaticImage
      src='../../technology/assets/images/attacks1.png'
      alt='schema of defense against byzantine attacks'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'technology-poisining-attacks-image-2': (
    <StaticImage
      src='../../technology/assets/images/attacks3.png'
      alt='schema of defense against backdoor attacks'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'technology-bias-prevention-image-1': (
    <StaticImage
      src='../../technology/assets/images/bias.png'
      alt='two silhouettes of men faced; the man on the left has thumbs up and the man of the right has thumbs down'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'technology-bias-prevention-image-2': (
    <StaticImage
      src='../../technology/assets/images/personalization.png'
      alt='personalization layer which helps to differentiate c and ç'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'technology-other-aspects-image-1': (
    <StaticImage
      src='../../technology/assets/images/smpc.png'
      alt='schema of secure multi party computation'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'technology-other-aspects-image-2': (
    <StaticImage
      src='../../technology/assets/images/psi.png'
      alt='schema of private set intersection'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'technology-synthetic-data-image-1': (
    <StaticImage
      src='../../technology/assets/images/synthetic_data_generation.png'
      alt='schema of synthetic data generation;  on the left side, a representation of the data of two different parties and its synthetic data created and on the right side, a three dimensional representation of the variables client, features and samples'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'technology-federated-learning-benefit-table ': (
    <StaticImage
      src='../../technology/assets/images/attacks1.png'
      alt='schema of defense against byzantine attacks'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'technology-twolayer': <StaticImage src='../../technology/assets/images/twolayer.png' alt='two layers' />,

  // SHARED
  'contact-sherpa-keynote': (
    <StaticImage
      src='../../shared/assets/images/xabi-uribe-etxebarria-stage-sherpa.jpg'
      alt='sherpa keynote'
      objectFit='contain'
      placeholder='blurred'
    />
  ),

  // ABOUT
  'leader-xabi': (
    <StaticImage
      src='../../about/assets/images/leader-xabi.png'
      alt='other profile picture of xabi uribe-etxebarria'
      objectFit='contain'
      placeholder='none'
    />
  ),
  'leader-joanna': (
    <StaticImage
      src='../../about/assets/images/leader-joanna.png'
      alt='profile picture of joanna hoffman'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'leader-tom': (
    <StaticImage
      src='../../about/assets/images/leader-tom.png'
      alt='other profile picture of tom gruber'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'leader-alex': (
    <StaticImage
      src='../../about/assets/images/leader-alex.png'
      alt='profile picture of alex cruz'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'leader-jasa': (
    <StaticImage
      src='../../about/assets/images/leader-jasa.png'
      alt='profile picture of javier santiso'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'leader-marcelo': (
    <StaticImage
      src='../../about/assets/images/leader-marcelo.png'
      alt='profile picture of marcelo gigliani'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'leader-doug': (
    <StaticImage
      src='../../about/assets/images/leader-doug.png'
      alt='other profile picture of doug solomon'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'leader-chris': (
    <StaticImage
      src='../../about/assets/images/leader-chris.png'
      alt='profile picture of chris shipley'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'placeholder-leader': (
    <StaticImage
      src='../../about/assets/images/leader-placeholder-rounded.png'
      alt='placeholder of leader picture'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'about-featured-quote': (
    <StaticImage
      src='../../about/assets/images/background-joanna.jpg'
      alt='other profile picture of joanna hoffman (desktop version)'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'about-featured-quote-mobile': (
    <StaticImage
      src='../../about/assets/images/background-joanna-mobile.jpg'
      alt='other profile picture of joanna hoffman (mobile version)'
      objectFit='contain'
      placeholder='blurred'
    />
  ),

  'award-0': (
    <StaticImage
      src='../../about/assets/images/awards/award-00-cogx-2021.png'
      alt='cognitionx winner 2021 award'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-1': (
    <StaticImage
      src='../../about/assets/images/awards/award-01-kpmg.png'
      alt='logo of kpmg'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-2': (
    <StaticImage
      src='../../about/assets/images/awards/award-02-ai-tech.png'
      alt='aitech awards'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-3': (
    <StaticImage
      src='../../about/assets/images/awards/award-03-cogx-2021-finalist.png'
      alt='cognitionx finalist 2021 award'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-4': (
    <StaticImage
      src='../../about/assets/images/awards/award-04-cogx-2021-finalist.png'
      alt='other cognitionx finalist 2021 award'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-5': (
    <StaticImage
      src='../../about/assets/images/awards/award-05-top-ai-2020.png'
      alt='top ai 100 winner 2020 award'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-6': (
    <StaticImage
      src='../../about/assets/images/awards/award-06-best-10-ai-2020.png'
      alt='the best 10 ai winner 2020 award'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-7': (
    <StaticImage
      src='../../about/assets/images/awards/award-07-cogx-2020-finalist.png'
      alt='cognitionx finalist 2020 award'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-8': (
    <StaticImage
      src='../../about/assets/images/awards/award-08-cogx-2020-finalist.png'
      alt='other cognitionx finalist 2020 award'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-9': (
    <StaticImage
      src='../../about/assets/images/awards/award-09-best-45-ai-2019.png'
      alt='the best 45 ai winner 2019 award'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-10': (
    <StaticImage
      src='../../about/assets/images/awards/award-10-analytics-insight-2019.png'
      alt='analytics insight top 100 artificial intelligence companies logo'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-11': (
    <StaticImage
      src='../../about/assets/images/awards/award-11-ai-breakthrough.png'
      alt='ai breakthrough award'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-12': (
    <StaticImage
      src='../../about/assets/images/awards/award-12-global-business-insight.png'
      alt='global business insight awards 2019'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-13': (
    <StaticImage
      src='../../about/assets/images/awards/award-13-red-herring.png'
      alt='red herring global winner'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-14': (
    <StaticImage
      src='../../about/assets/images/awards/award-14-seal-excelence.png'
      alt='european comission seal of excellence award'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-15': (
    <StaticImage
      src='../../about/assets/images/awards/award-15-alconics.png'
      alt='the alconics awards'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-16': (
    <StaticImage
      src='../../about/assets/images/awards/award-16-telecom-council.png'
      alt='telecom council logo'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-17': (
    <StaticImage
      src='../../about/assets/images/awards/award-17-cb-insights.png'
      alt='cb insights ai 100 winner 2018 award'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-18': (
    <StaticImage
      src='../../about/assets/images/awards/award-18-red-herring.png'
      alt=''
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-19': (
    <StaticImage
      src='../../about/assets/images/awards/award-19-best-app.png'
      alt='best app award winner'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-20': (
    <StaticImage
      src='../../about/assets/images/awards/award-20-white-bull.png'
      alt='white bull award'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-21': (
    <StaticImage
      src='../../about/assets/images/awards/award-21-cogx-2017-finalist.png'
      alt='cognitionx finalist 2017 award'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-22': (
    <StaticImage
      src='../../about/assets/images/awards/award-22-top-digital-50.png'
      alt='digital top 50 logo'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-23': (
    <StaticImage
      src='../../about/assets/images/awards/award-18-red-herring.png'
      alt='other red herring europe winner'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-24': (
    <StaticImage
      src='../../about/assets/images/awards/award-24-digital-client.png'
      alt='digital talent award'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'award-25': (
    <StaticImage
      src='../../about/assets/images/awards/award-25-intelligence.png'
      alt='b intelligence award'
      objectFit='contain'
      placeholder='blurred'
    />
  ),

  'hiring-desktop': (
    <StaticImage
      src='../../about/assets/images/hiring.png'
      alt='hiring stars (desktop version)'
      objectFit='contain'
      placeholder='blurred'
      formats={['PNG']}
    />
  ),
  'hiring-mobile': (
    <StaticImage
      src='../../about/assets/images/hiring-star-mobile.png'
      alt='hiring stars (mobile version)'
      objectFit='contain'
      placeholder='blurred'
    />
  ),

  // COVID19
  'covid-sexta-video': (
    <StaticImage
      src='../../covid19/assets/images/news/la-sexta.png'
      alt='video of la sexta'
      objectFit='cover'
      placeholder='blurred'
      height={293}
      width={519}
    />
  ),
  'covid-etb2-first-video': (
    <StaticImage
      src='../../covid19/assets/images/news/etb2-first.png'
      alt='video of etb 2'
      objectFit='cover'
      placeholder='blurred'
      height={293}
      width={519}
    />
  ),
  'covid-tve1-video': (
    <StaticImage
      src='../../covid19/assets/images/news/tve1.png'
      alt='video of tve 1'
      objectFit='cover'
      placeholder='blurred'
      height={293}
      width={519}
    />
  ),
  'covid-etb1-video': (
    <StaticImage
      src='../../covid19/assets/images/news/etb1.png'
      alt='video of etb 1'
      objectFit='cover'
      placeholder='blurred'
      height={293}
      width={519}
    />
  ),
  'covid-24h-video': (
    <StaticImage
      src='../../covid19/assets/images/news/24h.png'
      alt='video of tve 24h'
      objectFit='cover'
      placeholder='blurred'
      height={293}
      width={519}
    />
  ),
  'covid-etb2-second-video': (
    <StaticImage
      src='../../covid19/assets/images/news/etb2-second.png'
      alt='video of etb 2'
      objectFit='cover'
      placeholder='blurred'
      height={293}
      width={519}
    />
  ),
  'mikel-sanchez-blockquote': (
    <StaticImage
      src='../../covid19/assets/images/blockquotes/mikel-sanchez.png'
      alt='video of mikel sanchez'
      objectFit='cover'
      placeholder='blurred'
    />
  ),
  'placeholder-video': (
    <StaticImage
      src='../../covid19/assets/images/news/placeholder.png'
      alt='placeholder of video when loading'
      objectFit='cover'
      placeholder='blurred'
      height={293}
      width={519}
    />
  ),
  'la-sexta-tv-logo': (
    <StaticImage
      src='../../covid19/assets/images/tv/la-sexta.png'
      alt='logo of la sexta'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'tve-1-tv-logo': (
    <StaticImage
      src='../../covid19/assets/images/tv/tve-1.png'
      alt='logo of tve 1'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'tve-24h-tv-logo': (
    <StaticImage
      src='../../covid19/assets/images/tv/tve-24h.png'
      alt='logo og tve 24h'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'etb-1-tv-logo': (
    <StaticImage
      src='../../covid19/assets/images/tv/etb-1.png'
      alt='logo of etb 1'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'etb-2-tv-logo': (
    <StaticImage
      src='../../covid19/assets/images/tv/etb-2.png'
      alt='logo of etb 2'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'placeholder-tv-logo': (
    <StaticImage
      src='../../covid19/assets/images/tv/placeholder.png'
      alt='placeholder of tv logo when loading'
      objectFit='cover'
      placeholder='blurred'
    />
  ),

  // JOIN US
  'offices-desktop': (
    <StaticImage
      src='../../join-us/assets/images/office-erandio-desktop-sherpa.jpg'
      alt='erandio office (desktop version)'
      objectFit='cover'
      placeholder='blurred'
    />
  ),
  'offices-mobile': (
    <StaticImage
      src='../../join-us/assets/images/office-erandio-mobile-sherpa.jpg'
      alt='erandio office (mobile version)'
      objectFit='cover'
      placeholder='blurred'
    />
  ),
  'work-table-desktop': (
    <StaticImage
      src='../../join-us/assets/images/mesa-de-trabajo-desktop-sherpa.jpg'
      alt='work-table (desktop version)'
      objectFit='cover'
      placeholder='blurred'
    />
  ),
  'work-table-mobile': (
    <StaticImage
      src='../../join-us/assets/images/mesa-de-trabajo-mobile-sherpa.jpg'
      alt='work-table (mobile version)'
      objectFit='cover'
      placeholder='blurred'
    />
  ),
  // ESG
  'esg-xabi-quote': (
    <StaticImage
      src='../../esg/assets/images/xabi-quote.png'
      alt='xabi smiling and sitting'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'world-economic-forum': (
    <StaticImage
      src='../../esg/assets/images/world-economic-forum.png'
      alt='esg green ai'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'robot-nature': (
    <StaticImage
      src='../../esg/assets/images/robot_nature.png'
      alt='esg green ai'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'cambridge-university': (
    <StaticImage
      src='../../esg/assets/images/cambridge-university.png'
      alt='esg green ai'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'down-arrow': (
    <StaticImage
      src='../../esg/assets/images/down-arrow.png'
      alt='esg down arrow'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'quote-image': (
    <StaticImage
      src='../../esg/assets/images/quote-image.png'
      alt='esg quote h1'
      objectFit='contain'
      placeholder='blurred'
      height={26}
      width={36}
    />
  ),
  'robot-and-human-hands': (
    <StaticImage
      src='../../esg/assets/images/robot_and_human_hands.png'
      alt='esg responsible ai'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  // USE CASES
  // --> CARD HEADER LOGO
  'use-cases-prisa-logo': (
    <StaticImage
      src='../../home/assets/images/logos/logo-cliente-prisa.png'
      alt='white prisa logo'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'use-cases-orange-and-zurich-logo': (
    <StaticImage
      src='../../use-cases/orange-and-zurich/assets/images/card-header-image.png'
      alt='white indra logo'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'use-cases-telefonica-logo': (
    <StaticImage
      src='../../use-cases/telefonica/assets/images/card-header-image.png'
      alt='white telefonica logo'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'use-cases-nih-logo': (
    <StaticImage
      src='../../use-cases/nih/assets/images/card-header-image.png'
      alt='white nih logo'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'use-cases-prosegur-logo': (
    <StaticImage
      src='../../use-cases/prosegur/assets/images/card-header-image.png'
      alt='white prosegur logo'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  // --> CHALLENGE
  'use-cases-prisa-challenge': (
    <StaticImage
      src='../../use-cases/prisa/assets/images/challenge.png'
      alt='phone with blog page'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'use-cases-orange-and-zurich-challenge': (
    <StaticImage
      src='../../use-cases/orange-and-zurich/assets/images/challenge.png'
      alt='orange and zurich challenge'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'use-cases-telefonica-challenge': (
    <StaticImage
      src='../../use-cases/telefonica/assets/images/challenge.png'
      alt='telefonica challenge'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'use-cases-nih-challenge': (
    <StaticImage
      src='../../use-cases/nih/assets/images/challenge.png'
      alt='nih challenge'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'use-cases-prosegur-challenge': (
    <StaticImage
      src='../../use-cases/prosegur/assets/images/challenge.png'
      alt='prosegur challenge'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  // --> CHALLENGE
  'use-cases-prisa-about': (
    <StaticImage
      src='../../use-cases/prisa/assets/images/about.png'
      alt='about prisa with el pais logo'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'use-cases-orange-and-zurich-about': (
    <StaticImage
      src='../../use-cases/orange-and-zurich/assets/images/about.png'
      alt='blue indra logo'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'use-cases-telefonica-about': (
    <StaticImage
      src='../../use-cases/telefonica/assets/images/about.png'
      alt='blue telefonica logo'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'use-cases-nih-about': (
    <StaticImage
      src='../../use-cases/nih/assets/images/about.png'
      alt='gray nih logo'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'use-cases-prosegur-about': (
    <StaticImage
      src='../../use-cases/prosegur/assets/images/about.png'
      alt='black prosegur logo'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'use-cases-prisa-quote': (
    <StaticImage
      src='../../use-cases/prisa/assets/images/quote.png'
      alt='pablo delgado profile picture'
      objectFit='contain'
      placeholder='blurred'
    />
  ),
  'static-video-frame': (
    <StaticImage src='../../home/assets/images/videoframe.webp' alt='statuc-video-frame' objectFit='contain' />
  ),
  'kpmg-sherpa': <StaticImage src='../../news/assets/images/kpmg_sherpa.png' alt='kpmg sherpa' objectFit='contain' />,
  'siri-creator': (
    <StaticImage src='../../news/assets/images/siri_creator.png' alt='siri creator' objectFit='contain' />
  ),
  'telefonica-y-sherpa': (
    <StaticImage src='../../news/assets/images/telefonica_y_sherpa.png' alt='telefonica y sherpa' objectFit='contain' />
  ),
  'nih-sherpa': <StaticImage src='../../news/assets/images/nih_sherpa.png' alt='nih sherpa' objectFit='contain' />,
  'the-3-federated': <StaticImage src='../../platform/assets/images/the-3-federated.png' alt='the 3 federated' />,
  'plaform-secure': <StaticImage src='../../platform/assets/images/secure.png' alt='secure' />,
  checked: <StaticImage src='../../platform/assets/images/nike.png' alt='checked' />,
  'federated-transfer': (
    <StaticImage src='../../platform/assets/images/federated-transfer.png' alt='federated transfer' />
  ),
  'horizontal-federated': (
    <StaticImage src='../../platform/assets/images/horizontal-federated.png' alt='horizontal federated' />
  ),
  'vertical-federated': (
    <StaticImage src='../../platform/assets/images/vertical-federated.png' alt='vertical federated' />
  ),
  'build-your-model': <StaticImage src='../../platform/assets/images/build-your-model.png' alt='build-your-model' />,
  'file-systems': <StaticImage src='../../platform/assets/images/file-systems.png' alt='file-systems' />,
  'no-sql': <StaticImage src='../../platform/assets/images/no-sql.png' alt='No SQL' />,
  'sql-db': <StaticImage src='../../platform/assets/images/sql-db.png' alt='SQL DB' />,
  'files-aws': <StaticImage src='../../platform/assets/images/files-aws.png' alt='FILES AWS' />,
  'docker-logo': <StaticImage src='../../platform/assets/images/docker.png' alt='Docker' />,
  'robust-aggregators': (
    <StaticImage src='../../platform/assets/images/robust-aggregators.png' alt='robust aggregators' />
  ),
  differential_privacy: (
    <StaticImage src='../../platform/assets/images/differential_privacy.png' alt='differential privacy' />
  ),
};

export const useImage = key => {
  return key ? images[key] : null;
};

export default useImage;
